import { render, staticRenderFns } from "./SimpleActivityTable.vue?vue&type=template&id=cc3efac4&scoped=true&"
import script from "./SimpleActivityTable.vue?vue&type=script&lang=js&"
export * from "./SimpleActivityTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3efac4",
  null
  
)

export default component.exports